import React from 'react';
import Datetime from 'react-datetime';

require('moment/locale/lt');
import moment from 'moment';

export default function fateField(props) {
  const DATE_FORMAT = 'YYYY-MM-DD';

  let {
    onChange,
    value,
    timeFormat = 'HH:mm',
    noTimeZoneDate = false,
    ...restprops
  } = props;
  if (value) {
    if (noTimeZoneDate) {
      value = moment(value, DATE_FORMAT);
    } else {
      value = new Date(value);
    }
  }

  delete restprops.onFocus;
  return (
    <Datetime locale="lt"
              onChange={(value) => {
                if (moment.isMoment(value) && onChange) {
                  onChange(value);
                }
              }}
              {...restprops}
              dateFormat={DATE_FORMAT}
              timeFormat={timeFormat}
              value={value}
              utc={false}
    />);
}



// WEBPACK FOOTER //
// ./src/js/components/form/date-field.js